import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    API_GET_BALANCE: createActionType(FULL_NAMESPACE, "API_GET_BALANCE"),
    API_GET_BALANCE_COMPLETED: createActionType(FULL_NAMESPACE, "API_GET_BALANCE_COMPLETED"),
    API_GET_BALANCE_REJECTED: createActionType(FULL_NAMESPACE, "API_GET_BALANCE_REJECTED"),
    API_GET_REQUEST_STATISTICS: createActionType(FULL_NAMESPACE, "API_GET_REQUEST_STATISTICS"),
    API_GET_REQUEST_STATISTICS_COMPLETED: createActionType(FULL_NAMESPACE, "API_GET_REQUEST_STATISTICS_COMPLETED"),
    API_GET_REQUEST_STATISTICS_REJECTED: createActionType(FULL_NAMESPACE, "API_GET_REQUEST_STATISTICS_REJECTED")
};
